import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "orderable-container" }
const _hoisted_2 = ["id"]
const _hoisted_3 = { style: {"text-align":"left"} }
const _hoisted_4 = ["id", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_form_checkbox = _resolveComponent("b-form-checkbox")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(), _createElementBlock("div", {
        id: "sortable-list",
        class: "sortable-list",
        key: _ctx.modelValue
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (def) => {
          return (_openBlock(), _createElementBlock("div", {
            key: def.key,
            class: "dropdown-content-row"
          }, [
            (_ctx.columnOverride)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  id: def.key,
                  class: "item",
                  draggable: "true"
                }, [
                  _createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.getLabelFromFormDefinition(def)), 1)
                ], 8, _hoisted_2))
              : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  id: def.key,
                  class: "item",
                  draggable: "true",
                  onClick: ($event: any) => (def.hidden = !def.hidden)
                }, [
                  _createVNode(_component_b_form_checkbox, {
                    inline: "",
                    label: _ctx.getLabelFromFormDefinition(def),
                    "model-value": _ctx.dynamicColumns.some(x => _ctx.isEqual(x, def.key)),
                    onChange: (value) => _ctx.toggleColumn(value, def.key)
                  }, null, 8, ["label", "model-value", "onChange"])
                ], 8, _hoisted_4))
          ]))
        }), 128))
      ]))
    ])
  ]))
}